import History from '@/models/storePanel/History';
const getDefaultState = () => ({
  pointAnalysis: [],
  monthlyPoints: [],
});

export default {
  namespaced: true,

  state: () => getDefaultState(),

  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setPointAnalysis(state, payload) {
      state.pointAnalysis = payload;
    },

    setMonthlyPoints(state, payload) {
      state.monthlyPoints = payload;
    },
  },

  actions: {
    async getPointAnalysis({ commit }, body) {
      try {
        commit('setLoading', true, { root: true });

        let filter = '';
        Object.keys(body.filters).map((key) => {
          if (body.filters[key]) {
            filter += '&' + key + '=' + body.filters[key];
          }
        });

        const { data } = await History.getPointAnalysis(body.query + filter);

        const { pagination } = data.data;
        const coupons = data.data.data;

        commit('setPointAnalysis', coupons);
        commit('setServerItemsLength', pagination.total, {
          root: true,
        });
        commit('setServerPagination', pagination, {
          root: true,
        });
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex.response.data);
      }
    },

    async getMonthlyPoints({ commit }, query) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await History.getMonthlyPoints(query);

        const { monthly_store_point_history, pagination } = data.data;

        commit('setMonthlyPoints', monthly_store_point_history);
        commit('setServerItemsLength', pagination.total, {
          root: true,
        });
        commit('setServerPagination', pagination, {
          root: true,
        });
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex.response.data);
      }
    },
  },
};
